<div *ngIf="showCalendar" data-testId="user-events-calendar">
  <app-calendar [events]="events" [calendarId]="'eventsCalendar'" [calendarOptions]="calendarOptions"></app-calendar>
</div>

